export default {
  methods: {
    async inscription(response) {
      // debug console.log('inscription show plashScreen');
      this.$splashScreen('show');
      response.date = new Date().getTime();
      const setStore = [
        'app_token',
        'user',
        'multi',
        'referentiel',
        'cours',
        'negoce',
        'histo',
        'live',
        'quiz_data',
        'date',
      ].map(
        async (key) => {
          let val = response[key == 'quiz_data' ? 'quiz' : key];
          if (key == 'multi') {
            val = Object.keys(val).length ? val : {};
          }
          await this.ionicStorage.set(key, val);
        });

      setStore.push(this.ionicStorage.remove('onboarding'));

      await Promise.all(setStore);
      window.location.reload();
    }
  }
}